import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const ConsultationRecording = () => {
  const [recordingSettings, setRecordingSettings] = useState({
    allowRecording: false,
    qualityAssurance: true,
    trainingPurposes: false,
    clientCopy: false
  });

  const handleSettingChange = (key, value) => {
    setRecordingSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const recordingOptions = [
    {
      key: 'allowRecording',
      title: 'Beratungsaufzeichnung zulassen',
      description: 'Erlaubt die Aufzeichnung des Beratungsgesprächs für dokumentarische Zwecke',
      icon: 'Mic',
      color: 'text-primary'
    },
    {
      key: 'qualityAssurance',
      title: 'Qualitätssicherung',
      description: 'Verwendung für interne Qualitätskontrolle und Verbesserung der Beratungsqualität',
      icon: 'CheckCircle',
      color: 'text-success'
    },
    {
      key: 'trainingPurposes',
      title: 'Schulungszwecke',
      description: 'Anonymisierte Verwendung für die Ausbildung neuer Rechtsberater',
      icon: 'GraduationCap',
      color: 'text-accent'
    },
    {
      key: 'clientCopy',
      title: 'Kopie für Mandanten',
      description: 'Bereitstellung einer Aufzeichnung für Ihre eigenen Unterlagen',
      icon: 'Copy',
      color: 'text-warning'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-professional border border-slate-200 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Mic" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-text-primary">Beratungsaufzeichnung</h2>
          <p className="text-sm text-text-secondary">Kontrolle über Aufzeichnungen Ihrer Beratungsgespräche</p>
        </div>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
        <div className="flex items-start space-x-3">
          <Icon name="AlertTriangle" size={16} color="var(--color-warning)" className="mt-0.5" />
          <div>
            <h4 className="font-medium text-amber-800 mb-1">Wichtiger Hinweis</h4>
            <p className="text-sm text-amber-700">
              Alle Aufzeichnungen erfolgen nur mit Ihrer ausdrücklichen Einwilligung. 
              Sie können diese Einstellungen jederzeit ändern oder die Aufzeichnung während des Gesprächs beenden.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        {recordingOptions?.map((option) => (
          <div key={option?.key} className="flex items-start space-x-4 p-4 border border-slate-200 rounded-lg hover:bg-muted/30 transition-colors duration-200">
            <div className={`flex items-center justify-center w-10 h-10 bg-slate-100 rounded-lg ${option?.color}`}>
              <Icon name={option?.icon} size={18} />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-medium text-text-primary">{option?.title}</h3>
                <Checkbox
                  checked={recordingSettings?.[option?.key]}
                  onChange={(e) => handleSettingChange(option?.key, e?.target?.checked)}
                />
              </div>
              <p className="text-sm text-text-secondary mt-1">{option?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-slate-50 rounded-lg p-4 mb-4">
        <h4 className="font-medium text-text-primary mb-3">Technische Details</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-text-secondary">
          <div>
            <p><strong>Aufzeichnungsformat:</strong> MP3, 128 kbps</p>
            <p><strong>Speicherdauer:</strong> 10 Jahre (gesetzlich)</p>
            <p><strong>Verschlüsselung:</strong> AES-256</p>
          </div>
          <div>
            <p><strong>Zugriffsberechtigung:</strong> Nur autorisierte Berater</p>
            <p><strong>Löschung:</strong> Auf Anfrage möglich</p>
            <p><strong>Übertragung:</strong> SSL-verschlüsselt</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-slate-200">
        <div className="text-sm text-text-secondary">
          <p>Bei Fragen zur Aufzeichnung: <span className="text-primary">aufzeichnung@advocall.de</span></p>
        </div>
        <div className="flex space-x-3">
          <Button variant="outline" size="sm" iconName="Download">
            Richtlinie herunterladen
          </Button>
          <Button variant="default" size="sm" iconName="Save">
            Einstellungen speichern
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationRecording;